export default function getResource(label, vars = []) {
    const resources = {
        title: 'Économisez sur votre achat',
        creditCardTitle: 'Récompenses Carte de crédit',
        creditCardPrimaryText: `Jusqu’à ${vars[0]} $`,
        creditCardSecondaryText: 'disponible',
        applyInBasketButtonText: 'Appliquer dans le panier',
        creditCardLinkText: 'En savoir plus',
        rougeRewardsTitle: 'Récompenses Rouge',
        rougeRewardsPrimaryText: `${vars[0]} de réduction`,
        rougeRewardsSecondaryText: 'disponible',
        rougeRewardsExpiresText: `Expire le ${vars[0]}`,
        rougeRewardsButtonText: 'Appliquer',
        rougeRewardsLinkText: 'En savoir plus',
        biCashTitle: 'Dollars Beauty Insider',
        biCashPrimaryText: `Profitez de ${vars[0]} $ de réduction`,
        biCashSecondaryText: 'disponible',
        applyButtonText: 'Appliquer',
        biCashButtonTextChoose: 'Choisisr',
        biCashButtonTextApplied: 'Appliqué',
        biCashLinkText: 'En savoir plus',
        rougeBadge: 'EXCLUSIVITÉ ROUGE',
        biCashValueOff: `${vars[0]} de réduction`,
        biCashUpToOff: `Jusqu’à ${vars[0]} de réduction`,
        biCashForPoints: `pour ${vars[0]} points`,
        biCashTwoPromotionsPrefix: `${vars[0]} points = `,
        biCashTwoPromotionsSuffix: `${vars[0]} de réduction`,
        ctaApplied: 'Appliqué',
        ctaRemove: 'Supprimer',
        biCashPoints: 'points',
        biCashOff: 'de réduction',
        biCashUpTo: 'Jusqu’à',
        biCashFor: 'pour',

        // BEP-522 error modal strings
        errorTitle: 'Erreur',
        okButtonText: 'OK',
        emptyBasketError: 'Les marchandises, à l’exception des cartes-cadeaux, doivent être incluses dans votre commande pour bénéficier de cette offre.',
        insufficientBasketWarning: `Il vous reste ${vars[0]} sur votre Récompense Rouge. La Récompense Rouge est une offre ponctuelle qui expire 90 jours après utilisation. Si vous souhaitez utiliser la totalité de sa valeur, ajoutez d’autres articles à votre panier ou retirez la Récompense Rouge pour la faire valoir sur un achat ultérieur.`,
        // BEP-987 multiple RRC error
        multipleRrcError: 'You can apply one Rouge Reward per order. Please remove a reward applied in basket before adding another.'
    };

    return resources[label];
}
